export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGIN_AUTH_CHALLENGE = 'LOGIN_AUTH_CHALLENGE';
export const LOGIN_AUTH_CHALLENGE_SUCCESS = 'LOGIN_AUTH_CHALLENGE_SUCCESS';
export const LOGIN_AUTH_CHALLENGE_FAILURE = 'LOGIN_AUTH_CHALLENGE_FAILURE';

export const RESET_STATE_ON_LOGOUT = 'RESET_STATE_ON_LOGOUT';

export const SEND_FEEDBACK = 'SEND_FEEDBACK'

export const SET_BUCKET = 'SET_BUCKET';
export const ADD_TO_BUCKET = 'ADD_TO_BUCKET';
export const ADD_SNACKBAR_TO_BUCKET = 'ADD_SNACKBAR_TO_BUCKET';

export const ADD_EMPLOYERS = 'ADD_EMPLOYERS';
export const EMPLOYERS_LOADING = 'EMPLOYERS_LOADING';
export const EMPLOYERS_FAILED = 'EMPLOYERS_FAILED';
export const ADD_EMPLOYER = 'ADD_EMPLOYER';
export const UPDATE_EMPLOYER = 'UPDATE_EMPLOYER';
export const DELETE_EMPLOYER = 'DELETE_EMPLOYER';

export const ADD_EMPLOYER_WORKSITES = 'ADD_EMPLOYER_WORKSITES';
export const EMPLOYER_WORKSITES_LOADING = 'EMPLOYER_WORKSITES_LOADING';
export const EMPLOYER_WORKSITES_FAILED = 'EMPLOYER_WORKSITES_FAILED';
export const ADD_EMPLOYER_WORKSITE = 'ADD_EMPLOYER_WORKSITE';
export const UPDATE_EMPLOYER_WORKSITE = 'UPDATE_EMPLOYER_WORKSITE';
export const DELETE_EMPLOYER_WORKSITE = 'DELETE_EMPLOYER_WORKSITE';

export const ADD_EMPLOYEES = 'ADD_EMPLOYEES';
export const EMPLOYEES_LOADING = 'EMPLOYEES_LOADING';
export const EMPLOYEES_FAILED = 'EMPLOYEES_FAILED';
export const RESET_EMPLOYEES_ERROR = 'RESET_EMPLOYEES_ERROR';
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';

export const ADD_AUTHORIZATIONS = 'ADD_AUTHORIZATIONS';
export const AUTHORIZATIONS_LOADING = 'AUTHORIZATIONS_LOADING'
export const AUTHORIZATIONS_FAILED = 'AUTHORIZATIONS_FAILED'
export const ADD_AUTHZ = 'ADD_AUTHZ';
export const UPDATE_AUTHZ = 'UPDATE_AUTHZ';
export const DELETE_AUTHZ = 'DELETE_AUTHZ';

export const ADD_REMINDERS = 'ADD_REMINDERS';
export const REMINDERS_LOADING = 'REMINDERS_LOADING';
export const REMINDERS_FAILED = 'REMINDERS_FAILED';
export const ADD_REMINDER = 'ADD_REMINDER';
export const UPDATE_REMINDER = 'UPDATE_REMINDER';
export const DELETE_REMINDER = 'DELETE_REMINDER';

export const ADD_TASKS = 'ADD_TASKS';
export const TASKS_LOADING = 'TASKS_LOADING';
export const TASKS_FAILED = 'TASKS_FAILED';
export const ADD_TASK = 'ADD_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';

export const ADD_CLIENTS = 'ADD_CLIENTS';
export const CLIENTS_LOADING = 'CLIENTS_LOADING';
export const CLIENTS_FAILED = 'CLIENTS_FAILED';
export const ADD_CLIENT = 'ADD_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';

export const ADD_CLIENT_SUBCONS = 'ADD_CLIENT_SUBCONS';
export const CLIENT_SUBCONS_LOADING = 'CLIENT_SUBCONS_LOADING';
export const CLIENT_SUBCONS_FAILED = 'CLIENT_SUBCONS_FAILED';
export const ADD_CLIENT_SUBCON = 'ADD_CLIENT_SUBCON';
export const UPDATE_CLIENT_SUBCON = 'UPDATE_CLIENT_SUBCON';

export const ADD_CLIENT_SUBCONTRACTED = 'ADD_CLIENT_SUBCONTRACTED';
export const CLIENT_SUBCONTRACTED_LOADING = 'CLIENT_SUBCONTRACTED_LOADING';
export const CLIENT_SUBCONTRACTED_FAILED = 'CLIENT_SUBCONTRACTED_FAILED';

export const ADD_CLIENT_SUBCONTRACTED_BCU = 'ADD_CLIENT_SUBCONTRACTED_BCU';
export const CLIENT_SUBCONTRACTED_BCU_FAILED = 'CLIENT_SUBCONTRACTED_BCU_FAILED';

export const ADD_RSVTI_OPERATORS = 'ADD_RSVTI_OPERATORS';
export const RSVTI_OPERATORS_LOADING = 'RSVTI_OPERATORS_LOADING';
export const RSVTI_OPERATORS_FAILED = 'RSVTI_OPERATORS_FAILED';
export const ADD_RSVTI_OPERATOR = 'ADD_RSVTI_OPERATOR';
export const UPDATE_RSVTI_OPERATOR = 'UPDATE_RSVTI_OPERATOR';

export const ADD_USERS = 'ADD_USERS';
export const USERS_LOADING = 'USERS_LOADING';
export const USERS_FAILED = 'USERS_FAILED';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';

export const ADD_EMPLOYEE_COURSES = 'ADD_EMPLOYEE_COURSES';
export const EMPLOYEE_COURSES_LOADING = 'EMPLOYEE_COURSES_LOADING';
export const EMPLOYEE_COURSES_FAILED = 'EMPLOYEE_COURSES_FAILED';
export const RESET_EMPLOYEE_COURSES_ERROR = 'RESET_EMPLOYEE_COURSES_ERROR';
export const ADD_EMPLOYEE_COURSE = 'ADD_EMPLOYEE_COURSE';
export const UPDATE_EMPLOYEE_COURSE = 'UPDATE_EMPLOYEE_COURSE';
export const DELETE_EMPLOYEE_COURSE = 'DELETE_EMPLOYEE_COURSE';

export const ADD_COR_CODES = 'ADD_COR_CODES';
export const COR_CODES_LOADING = 'COR_CODES_LOADING';
export const COR_CODES_FAILED = 'COR_CODES_FAILED';
export const RESET_COR_CODES_ERROR = 'RESET_COR_CODES_ERROR';
